export default "__VITE_ASSET__CAgTEbHN__"